export default __webpack_public_path__ + "static/media/mediaPlay.58a3a1e5.svg";